module.exports = __webpack_public_path__ + "media/hiss.a85cab12.wav";